module.exports = __webpack_public_path__ + "img/gather_ruffle.8d0f03bd.png";